import { render, staticRenderFns } from "./TextBar.vue?vue&type=template&id=131cde13&"
import script from "./TextBar.vue?vue&type=script&lang=js&"
export * from "./TextBar.vue?vue&type=script&lang=js&"
import style0 from "./TextBar.vue?vue&type=style&index=0&id=131cde13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports